import type { StyleProp, ViewStyle } from 'react-native';

import { getStyleSheet } from './style-sheet-memo';

export const rounded = (borderRadius: number) =>
  getStyleSheet({ borderRadius });

// We should use type BorderStyle = ViewStyle['borderStyle'];
// But there is no way to do assert that a prop is a BorderStyle
// So until that becomes possible in TS, we need to add new border styles to BORDER_STYLES as needed
const BORDER_STYLES = ['solid', 'dotted', 'dashed'] as const;

type BorderStyle = typeof BORDER_STYLES[number];

function isBorderStyle(borderStyle: string): borderStyle is BorderStyle {
  return BORDER_STYLES.includes(borderStyle as BorderStyle);
}
type BorderWidth = ViewStyle['borderWidth'];

export const border = (
  ...params: (BorderWidth | BorderStyle)[]
): StyleProp<Pick<ViewStyle, 'borderStyle' | 'borderWidth'>> => {
  const styles: ViewStyle[] = [];

  params.forEach((prop: BorderStyle | BorderWidth) => {
    switch (typeof prop) {
      case 'number':
        styles.push({ borderWidth: prop });
        break;

      case 'string':
        if (isBorderStyle(prop)) {
          styles.push({ borderStyle: prop });
        }
        break;

      default:
        break;
    }
  });

  return getStyleSheet(styles);
};

export const borderRadius = (borderRadius: ViewStyle['borderRadius']) =>
  getStyleSheet({ borderRadius });
